import React, { useState } from 'react';
import { Typography, Checkbox, FormControlLabel, Button, Grid, CircularProgress, Box, TextareaAutosize } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation } from 'react-router-dom';

function OptInScreen() {
    const location = useLocation();
  	const userData = location.state && location.state.userData;
    const [isChecked, setIsChecked] = useState(false);
    const [showError, setShowError] = useState(false);
    const [apiResponse, setApiResponse] = useState('');
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showResult, setShowResult] = useState('');
    const apiUrl = process.env.REACT_APP_API_URL_PROD || '';
    
    const useStyles = makeStyles((theme) => ({
        optInForm: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: theme.spacing(2),
        },
        formBox: {
            padding: theme.spacing(4),
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            backgroundColor: '#f4f7fd',
            marginTop: theme.spacing(2), 
        },
        legalText: {
            marginBottom: theme.spacing(2),
        },
        submitButton: {
            marginTop: theme.spacing(2),
        },
        errorText: {
            color: 'red',
            marginTop: theme.spacing(1),
        },
        thankYouText: {
            textAlign: 'center',
            marginTop: '24px !important',
            wordWrap: "break-word",
        },
    }));
    const classes = useStyles();
 
    const handleTestButtonClick = () => {
        fetch(apiUrl + '/api/run_test', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({ userData: userData}, null, 2),
        })
        .then((response) => response.json())
        .then((data) => {
            //console.log('Test Result:', data);
            setShowResult(`API called Successfully!\n${JSON.stringify(data, null, 2)}`);
        })
        .catch((error) => {
            console.error('Error calling /api/run_test:', error);
        });
    };

    const handleCheckboxChange = (event) => {
      setIsChecked(event.target.checked);
    };
    
    const handleSubmit = async (event) => {
      event.preventDefault();
      setApiResponse('');
  
      if (!isChecked) {
        setShowError(true);
      } else {
        setShowError(false);
        setLoading(true);

        try {           
            fetch(apiUrl + '/api/save_submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                },
                body: JSON.stringify({ userData: userData, optInDate: new Date().toLocaleString() + ""  }, null, 2),
            })
            .then((response) => response.json())
            .then((data) => {
                const newData = decodeURI(data["response"]);
                setApiResponse(newData);
                setLoading(false);
                setSubmitted(true);
            })
            .catch((error) => {
                console.error('Error in save_submit fetch: ', error);
                setLoading(false);
            });
       } catch (err) {
         console.log("Error calling /api/save_submit", err);
       }
      } //end if/else
    }; //end handleSubmit
    
    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid item xs={2}/>
            <Grid item xs={6} alignItems="center">
                <Box className={classes.formBox}>
                <Typography variant="h4" component="h4" align="center">SideKick for PSA</Typography>
                {!submitted ? (   
                    <form className={classes.optInForm} onSubmit={handleSubmit}>
                        <Typography variant="body1" className={classes.legalText}>
                        Once you click submit below we will add a SideKick for PSA entry to your Manage Hosted API setup table.
                        <br /><br />These terms govern your use of Artificial Intelligence (“AI”) and Large Language Models (“LLM”) services or features, including but not limited to Open AI, that ConnectWise makes available without additional charge (“AI Services”). 
                        <br /><br />You acknowledge and agree that AI Services are offered “as-is” without warranty of any kind. ConnectWise makes no representations or warranties for AI Services, including that any information you submit to the AI Services will be secure or not lost or damaged.  
                        <br /><br />You agree that you are responsible to review and test any generated content before usage or deployment.
                        </Typography>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    color="primary"
                                />
                            }
                            label="I agree to the above terms and conditions"
                        />
                        {showError && (
                            <Typography variant="body2" className={classes.errorText}>
                                Please agree to the terms and conditions.
                            </Typography>
                        )}
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submitButton}
                            disabled={!isChecked}
                        >
                            Submit
                        </Button>
                        <Grid item xs={12}>
                            {!apiResponse && loading ? (
                                <div style={{ textAlign: 'center' }}>
                                    <CircularProgress />
                                </div>
                                ) : (
                                <div />
                            )}
                        </Grid>                    
                    </form>
                    ) : (
                    <Typography variant="h5" className={classes.thankYouText}>
                        Thank you! <br/>A SideKick for PSA entry has been added to your Manage Hosted API setup table.
                    </Typography>                       
                 )}
                </Box>      
            </Grid>
            <Grid item xs={2}/>
            <Grid item xs={10} align="center"> 
                <>
                    {userData && (userData.memberId === "jmalek" || userData.memberId === "zadmin") && (
                        <Box>
                            <Button variant="contained" onClick={handleTestButtonClick}>API Test</Button>
                            < br/>
                            <TextareaAutosize aria-label="empty textarea" placeholder="" minRows={4} value={showResult} style={{ width: "600px" }}/>
                        </Box>

                    )}
                </>
            </Grid>
        </Grid>
    );
}    
export default OptInScreen;